import { useEffect, useState } from 'react';
import axios from 'axios';
import LightAdmin from 'components/headers/lightAdmin';
import AnimationRevealPage from 'helpers/AnimationRevealPage';
import Footer from "components/footers/FiveColumnWithInputForm.js";
import { useTranslation } from 'react-i18next';

const ClientAdmin = () => {
    const { t } = useTranslation();
    const [customers, setCustomers] = useState([]);
    const [isAdmin, setIsAdmin] = useState(false);
const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        checkAdminStatus();
    }, []);
    const checkAdminStatus = () => {
        const isAdmin = localStorage.getItem('isAdmin') === '1';
        setIsAdmin(isAdmin);

        if (isAdmin) {
            fetchAllCustomers();
        } else {
                return;
        }
    };
    const fetchAllCustomers = async () => {
        try {
            const token = localStorage.getItem('authToken');
            if (!token) {
                return;
            }
    
            const response = await axios.get('https://elanciabioapi.com/api/admin/customers', {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            });
    
            if (response.status === 200) {
                setCustomers(response.data);
            } else {
                return;
            }
        } catch (error) {
                return;
        }
    };
    
    if (!isAdmin) {
        return <p className="text-danger text-center">Unauthorized: You do not have admin access.</p>;
    }
const filteredCustomers = customers.filter(customer =>
  customer.Name?.toLowerCase().includes(searchTerm.toLowerCase())
);
console.log(filteredCustomers);
    return (
        <AnimationRevealPage>
            <LightAdmin />  <div className="d-flex flex-column flex-md-row">
        <section className="w-100 p-3">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h1 className="text-dark display-4">{t('Tableau_de_bord_Clients')}</h1>
            <input
              type="text"
              className="form-control w-25"
              placeholder={t('Rechercher_par_nom')}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
                    <hr className="my-4" />

                    {/* Customers Table - Make it responsive */}
                    <div className="table-responsive">
                        <table className="table table-striped table-hover">
                            <thead className="table-primary">
                                <tr>
                                    <th>{t('ID_Client')}</th>
                                    <th>{t('ID_Fournisseur')}</th>
                                    <th>{t('Nom')}</th>
                                    <th>{t('Numéro_de_Téléphone')}</th>
                                    <th>{t('Adresse')}</th>
                                    <th>{t('Cree_le')}</th>
                                </tr>
                            </thead>
                            <tbody>
{filteredCustomers.map((customer) => (
                                    <tr key={customer.CustomerID}>
                                        <td>{customer.CustomerID}</td>
                                        <td>{customer.SupplierCustomID}</td>
                                        <td>{customer.Name}</td>
                                        <td>{customer.Phone || 'N/A'}</td>
                                        <td>{customer.Address}</td>
                                        <td>{new Date(customer.created_at).toLocaleString()}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </section>
            </div>
            <Footer />
        </AnimationRevealPage>
    );
};

export default ClientAdmin;
